import { Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import SuspenseFallback from './SuspenseFallback';
import { routes } from 'src/shared/routes';

/**
 * The routed page.
 *
 * Add your own routes by adding a feature under `src/features/<name>/` and
 * spreading its `routes.ts` into `src/shared/routes.ts` — nothing here changes.
 *
 * The leading slash is stripped because this `<Routes>` is nested under the
 * shell's `path="/*"` in `App.tsx`: React Router rejects absolute paths in a
 * descendant route tree. Features keep declaring `'/'` and `'/clients'`, which
 * is what reads well at the call site.
 */
const toDescendantPath = (path: string) => path.replace(/^\//, '');

const AppContent = () => (
  <Suspense fallback={<SuspenseFallback />}>
    <Routes>
      {routes.map((route) => (
        <Route key={route.path} path={toDescendantPath(route.path)} element={<route.element />} />
      ))}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  </Suspense>
);

export default AppContent;
